import { ApiResponse, getData, postJson } from './Apis';

export type EmailAddressVerificationStatus = {
    EmailAddress: string,
    Status: number,
    Type: number,
}

export enum  Status {
    Verified = 0,
    Unverified = 1,
    Unknown = 2,
    InvalidCode = 3
}

export async function API_SendVerificationEmail() {
    return await getData<any>("webapi/candidate/user/SendVerificationEmail");
}

export async function API_CheckVerificationEmail() {
    return await postJson<any>("webapi/candidate/user/CheckVerificationEmail");
}

export async function API_VerifyEmailAddress(code: string) {
    return await getData<ApiResponse<EmailAddressVerificationStatus>>(`webapi/candidate/emailverification/verifyemail/${code}`)
}